<div
  class="flex items-center justify-center text-center py-1 px-2"
  *ngIf="currentMessage"
  [ngStyle]="{
    'height': '40px',
    'font-size': '14px',
    'background-color': backgroundColor,
    'color': textColor
  }"
>

<button *ngIf="config?.messageList?.length > 1" class="font-semibold text-sm py-1 px-3 rounded mr-[60px]" (click)="onPrevClick()">
  <fa-icon icon="chevron-left"></fa-icon>
</button>

<div class="relative w-[800px] overflow-hidden justify-center h-10 flex items-center">
  <div
    #textEl
    [ngClass]="{
      '': !shouldMarquee,
      'absolute whitespace-nowrap animate-marquee': shouldMarquee
    }"
    [ngStyle]="shouldMarquee? {animation:  ('marquee ' + marqueeDuration + 's linear infinite')}:{ }"
    [innerHTML]="currentMessage | safeHtml"
  ></div>
</div>

<button *ngIf="config?.messageList?.length > 1"  class="font-semibold text-sm py-1 px-3 rounded ml-[60px]" (click)="onNextClick()">
  <fa-icon icon="chevron-right"></fa-icon>
</button>

</div>